import { useState } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { Requirement, Select, CourseSet } from "../../types/requirement.response";
import ChecklistCourseSetSlots from "./ChecklistCourseSetSlots";
import RequirementTabBar from "../shared/RequirementTabBar";

interface ChecklistOptionGroupSectionProps {
    rootNode: Select;
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
}

export default function ChecklistOptionGroupSection({
    rootNode,
    requirement,
    coursesMap,
    onAdd,
    onDelete,
}: ChecklistOptionGroupSectionProps) {
    const groups = rootNode.children.filter(
        (child): child is Select => child.type === "SELECT"
    );
    const [activeTab, setActiveTab] = useState(0);

    if (groups.length === 0) return null;

    const activeGroup = groups[activeTab];
    const courseSets = activeGroup.children.filter(
        (child): child is CourseSet => child.type === "COURSE_SET"
    );

    return (
        <div>
            <RequirementTabBar
                items={groups}
                fulfilledIds={rootNode.fulfilledChildIds}
                activeTab={activeTab}
                onTabChange={setActiveTab}
            />

            <div className="mt-3 flex flex-col gap-3">
                {courseSets.map(courseSet => (
                    <ChecklistCourseSetSlots
                        key={courseSet.id}
                        courseSet={courseSet}
                        coursesMap={coursesMap}
                        requirementId={requirement.info.id}
                        onAdd={(course) => onAdd(course, courseSet.id)}
                        onDelete={onDelete}
                        idPrefix="checklist-option-group"
                        label={courseSet.title ?? undefined}
                    />
                ))}
            </div>
        </div>
    );
}
